import React from 'react';
import { LinearProgress, lighten, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
const classes = {
    root: {
        width: '100%',
        minHeight: '20vh',
    },
    progressBar: {
        height: '8px',
        padding: '10px 0',
    },
    limit: {
        margin: '5px',
        minWidth: '220px',
    },
};
const CustomLinearProgress = styled(LinearProgress)(() => ({
    height: 10,
    backgroundColor: lighten('#ff6c5c', 0.5),
}));
export const SharedUI = ({ completed, fileListObject, myQueryLimit, }) => {
    var _a;
    const COMPLETE = 100; // Percentage
    const datasets = fileListObject
        ? fileListObject.filter((element) => element.datasetId !== '')
        : [];
    const datasetFileCount = fileListObject &&
        datasets.reduce((count, dataset) => count + dataset.fileList.length, 0);
    const fileCount = fileListObject
        ? ((_a = fileListObject.find((element) => element.datasetId === '')) === null || _a === void 0 ? void 0 : _a.fileList.length) || 0
        : 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: classes.progressBar },
            React.createElement(CustomLinearProgress, { variant: 'determinate', value: completed })),
        completed === COMPLETE ? (React.createElement(Typography, { align: 'center' }, `Link collection ready (limited to ${myQueryLimit} datasets).
            Found ${fileListObject && datasets.length} datasets containing
             ${datasetFileCount} file links and ${fileCount} single file(s).`)) : (React.createElement(Typography, { align: 'center' },
            "Compiling filelist, ",
            completed,
            " % complete. (limited to ",
            myQueryLimit,
            ' ',
            "datasets)"))));
};
